import { IconProps } from "./types";

export const ClockIcon = ({
  size = 18,
  color = "currentColor",
  className,
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.997 12.834a5.833 5.833 0 1 0 0-11.667 5.833 5.833 0 0 0 0 11.667"
      fill={color}
      fill-opacity=".2"
    />
    <path
      d="M9.163 9.292a.4.4 0 0 1-.221-.065L7.133 8.148c-.449-.268-.781-.857-.781-1.376V4.38a.44.44 0 0 1 .437-.438.44.44 0 0 1 .438.438v2.392c0 .21.175.519.355.624l1.809 1.079c.21.122.274.39.151.6a.45.45 0 0 1-.379.217"
      fill={color}
      fill-opacity=".8"
    />
  </svg>
);
